// removed by extract-text-webpack-plugin
module.exports = {"results":"_1xfnH","subHeader":"_1ic4w","rowWrapper":"_3Z8yC","rowWrapperHeader":"_1Yg8v","pdfIcon":"_247x8","fileName":"_2GTGs","viewText":"_3TLx1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Documents/Documents.scss
// module id = 2623
// module chunks = 0